import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { GeocoderResultsProps } from "./Geocoder.types";
import ListItem from "../../core/list/ListItem";
import List from "../../core/list/List";
import { cn } from "../../../util/classNameConstructor";

const Results: FC<GeocoderResultsProps> = ({
  results,
  onSelected,
  setShowResults,
  handleGeolocate,
  extraOptions,
  geolocateLoading,
  className,
  activeResultIndex,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cn("max-w-[calc(100vw_-_30px)]", className)}>
      <List
        borderless
        data={[
          ...(results || []).map((item, index) => {
            const secondaryContent = [
              item?.context?.[0]?.text,
              item?.context?.[1]?.text,
              item?.context?.[2]?.text,
            ]
              .filter((text) => text != null)
              .join(", ");

            const primaryContent =
              item?.place_type?.[0] === "region" ||
              item?.place_type?.[0] === "place"
                ? item?.place_name.split(",")[0]
                : item?.place_type?.[0] === "locality" ||
                    item?.place_type?.[0] === "district"
                  ? item?.place_name.split(",").slice(0, 2).join(", ")
                  : item?.place_name.split(",")[0];
            return (
              <ListItem
                onClick={(event) => onSelected(item, event)}
                index={index}
                id={`geocoder_result${index}`}
                key={`geocoder_result${index}`}
                lines={1}
                tag="div"
                primaryContent={primaryContent}
                secondaryContent={secondaryContent}
                leadingIcon="pin"
                classNames={{
                  textArea: "justify-center",
                  base:
                    activeResultIndex === index
                      ? "bg-action-tertiary-hovered"
                      : "",
                }}
                tabIndex={0}
                aria-selected={activeResultIndex === index}
              />
            );
          }),
          ...(extraOptions
            ? [
                <ListItem
                  onClick={handleGeolocate}
                  id="geolocate"
                  key="geolocate"
                  primaryContent={t("dialogMap:add.geolocate")}
                  leadingIcon={geolocateLoading ? "loading" : "locate-arrow"}
                  lines={2}
                  tabIndex={0}
                  classNames={{
                    base:
                      activeResultIndex === results.length
                        ? "bg-action-tertiary-hovered"
                        : "",
                  }}
                />,
                <ListItem
                  onClick={() => setShowResults(false)}
                  id="geolocate_hide"
                  key="geolocate_hide"
                  primaryContent={t("dialogMap:add.findOnMap")}
                  leadingIcon="pin-alt"
                  lines={2}
                  tabIndex={0}
                  classNames={{
                    base:
                      activeResultIndex === results.length + 1
                        ? "bg-action-tertiary-hovered"
                        : "",
                  }}
                />,
              ]
            : []),
        ]}
      />
    </div>
  );
};

export default Results;
